<template>
  <div>
    <v-container>
      <v-layout>
        <v-expansion-panel dark v-model="panel" expand>
          <v-expansion-panel-content style="background: #084776">
            <template v-slot:header>
              <div>Pretraga</div>
              <v-spacer></v-spacer>
              <v-divider class="mx-2" vertical></v-divider>
            </template>
            <v-card light>
              <v-layout row wrap justify-center>
                <v-flex xs10 pr-4>
                  <v-autocomplete
                    clearable
                    v-model="Fakulteti"
                    :items="Sastavnice"
                    item-text="title"
                    return-object
                    label="Odaberite fakultet... *"
                    @change="assignDataStudiji(Fakulteti.id)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs10 pr-4>
                  <v-autocomplete
                    clearable
                    v-model="kolegiji"
                    :items="studiji"
                    item-text="naziv"
                    return-object
                    label="Odaberite studij... *"
                    @change="assignDataKolegiji(kolegiji.id)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs10 pr-4>
                  <v-autocomplete
                    clearable
                    v-model="odabraniSemestar"
                    :items="semestri"
                    item-text="naziv"
                    return-object
                    label="Odaberite semestar..."
                    @change="assignDataSemestar(odabraniSemestar)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs10 pr-4>
                  <v-autocomplete
                    clearable
                    v-model="tipRoka"
                    :items="stringRokova"
                    item-text="roki"
                    return-object
                    label="Odaberite ispitni rok..."
                    @change="assignDataRok(tipRoka.a)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs10 pr-4>
                  <v-autocomplete
                    clearable
                    v-model="test"
                    :items="PomVarSem"
                    item-text="predmet.naziv"
                    return-object
                    label="Odaberite predmet..."
                    @change="assignDataRokovi(test.predmet.id)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12>
                  <v-card class="grey lighten-3" dark>
                    <v-layout justify-center>
                      <v-flex xs10 pr-4>
                        <v-card-actions style="padding-right: 0px">
                          <v-spacer></v-spacer>
                          <v-btn flat style="background: red" @click="reload()">
                            <v-icon class="fas fa-times left"></v-icon>
                            <span class="pl-2">Poništi</span>
                          </v-btn>
                        </v-card-actions>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-layout>
    </v-container>
    <v-container class="pt-0">
      <v-card>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-progress-linear v-if="progress" :indeterminate="true" color="primary"></v-progress-linear>
          </div>

          <table v-if="Object.keys(rokoviid2).length !== 0" class="hidden-xs-only" id="velikaT">
            <tr>
              <th colspan="5" class="py-3" id="tableHead">
                <span>Studij: {{ kolegiji.naziv }} Akademska godina : {{new Date().getFullYear() - 1}}./{{new Date().getFullYear()}}.</span>
              </th>
            </tr>
            <tr style="background-color: whitesmoke">
              <th class="py-2">Predmet</th>
              <th>Datum roka</th>
              <th>Prijava do</th>
              <th>Odjava do</th>              
              <th>Dodaj u Google kalendar</th>
            </tr>
            <tr v-for="x in rokoviid2" :key="x.id" id="velikaR">
              <td id="velikatd">
                <span>{{ x.predmet.naziv }}</span>
              </td>

              <td>
               <b> <span>{{ [ x.datum_roka, "YYYY-MM-DD HH:mm:ss" ] | moment("DD.MM.YYYY. HH:mm")}}</span></b>
                
              </td>
              <td>
                <span>{{ [ x.datum_roka, "YYYY-MM-DD HH:mm:ss" ] | moment("subtract", "3 days", "DD.MM.YYYY. HH:mm")}}</span>
              </td>
              <td>
                <span>{{ [ x.datum_roka, "YYYY-MM-DD HH:mm:ss" ] | moment("subtract", "1 days", "DD.MM.YYYY. HH:mm")}}</span>
              </td>
              <td>
                <v-btn
                  style="color:#4285F4"
                  flat
                  @click="pretvaranjeVremena(x.datum_roka), kalendar(x.predmet.naziv)"
                >
                  <v-icon style="color:#4285F4" class="fab fa-google"></v-icon>
                </v-btn>
              </td>
            </tr>
          </table>

          <table v-if="Object.keys(rokoviid2).length !== 0" class="hidden-sm-and-up">
            <tr v-for="x in rokoviid2" :key="x.id">
              <td width="50%" id="mobilnitd">
                <b>
                  <span style="color:#084776">Predmet:</span>
                </b>
                <br>
                {{ x.predmet.naziv }}
                <br>
                <hr>
                
                <b>
                  <span style="color:#084776">Datum roka:</span>
                </b>
                <br>
                {{x.datum_roka}}
                <br>
                <hr>
              </td>

              <td id="mobilnitd">
                Dodaj u Google kalendar:
                <br>
                <v-btn
                  style="color:#4285F4"
                  flat
                  @click="pretvaranjeVremena(x.datumRoka), kalendar(x.predmet.naziv)"
                >
                  <v-icon style="color:#4285F4" class="fab fa-google"></v-icon>
                </v-btn>
              </td>
            </tr>
          </table>
          <div v-else align="center"> <span style="display: inline-block">Nema rezultata za prikaz</span>
          </div>
        </v-flex>

        <v-flex xs10 ma-auto v-if="this.brojac > 10">
          <div class="justify-center, text-xs-center">
            <v-btn icon :disabled="startPaginacija == 0?true:false" @click="paginacijaBefore()">
              <v-icon style="color:#084776" large>fas fa-arrow-circle-left</v-icon>
            </v-btn>

            <v-btn
              icon
              :disabled="brojac - startPaginacija <=10?true:false"
              @click="paginacijaNext()"
            >
              <v-icon style="color:#084776" large>fas fa-arrow-circle-right</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  methods: {
    reload() {
      this.Fakulteti = [];
      this.kolegiji = [];
      this.odabraniSemestar = undefined;
      this.test = [];
      this.tipRoka = undefined;
      this.rokoviid2 = [];
      this.startPaginacija = 0;
      this.brojac = 0;
      this.rokoviidBrojac = [];
      this.studiji = [];
      this.idKolegija = "";
    },

    assignDataStudiji(val1) {
      (this.test = []), (this.idStudija = null), (this.rokoviidbrojac = []);
      this.idFakulteta = val1;
      this.getStudiji(val1);
      this.brojac = 0;
    },
    assignDataKolegiji(val1) {
      (this.odabraniSemestar = undefined), (this.tipRoka = undefined);
      this.idStudija = val1;
      this.getPredmeti(val1);

      this.brojac = 0;
    },
    assignDataRokovi(val1) {
      this.idKolegija = val1;
      this.rokoviid2 = this.glavniFilter;
      this.brojac = 0;
    },
    assignDataRok(val1) {
      this.tipRoka = val1;
      this.rokoviid2 = this.glavniFilter;
      this.brojac = 0;
    },
    assignDataSemestar(val1) {
      this.semestar = val1;
      this.rokoviid2 = this.glavniFilter;
      this.PomVarSem = this.glavniFilter;
      (this.test = []), (this.brojac = 0);
      this.rokoviidBrojac = this.PomVar3;
      
    },
    paginacijaNext() {
      this.startPaginacija += 10;
      this.assignDataKolegiji(this.kolegiji.id);
    },
    paginacijaBefore() {
      this.startPaginacija -= 10;
      this.assignDataKolegiji(this.kolegiji.id);
    },

    pretvaranjeVremena(date) {
      (date = this.$moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYYMMDDTHHmm")),
        (this.novovrijeme = date),
        (date = this.$moment(this.novovrijeme)
          .add("1", "hours")
          .format("YYYYMMDDTHHmm")),
        (this.novovrijeme1 = date);

      // window.console.log(this.novovrijeme);
      // window.console.log(this.novovrijeme1);
    },

    kalendar(varpred) {
      window.open(
        "https://www.google.com/calendar/render?action=TEMPLATE&text=" +
          varpred +
          ": Ispitni rok" +
          "&dates=" +
          this.novovrijeme +
          "00/" +
          this.novovrijeme1 +
          "00"
      );
    },

    getStudiji(idFakulteta) {
          var config = {
            headers: {
              "Content-Type": "application/json"
            },
            params: {
              sastavnica: idFakulteta,
              perPage: -1
            } 
          };

          var url1 ="https://api.sum.ba/studiji"

          axios
            .get(url1, config)
            .then(response => {
              this.studiji = response.data.data;
             //  window.console.log(this.studiji);
            })
            .catch(error => window.console.log(error.message));
        
    },
    getPredmeti(idStudija) {
      this.progress = true;
      var config = {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
              studij_id: idStudija,
              perPage: -1
            } 
      };

      var url1 = "https://api.sum.ba/rokovi"

     // var url2 = url1 + "&limit=10&start=" + this.startPaginacija;

      // window.console.log(url);
      axios
        .get(url1, config)
        .then(response => {
          this.PomVarSem = response.data;
          this.rokoviidBrojac = response.data;
          this.brojac = this.rokoviidBrojac.length;
          this.progress = false;
          this.PomVar3 = response.data;
         // window.console.log(response.data);
        })
        .catch(error => window.console.log(error.message));

      axios
        .get(url1, config)
        .then(response => {
          this.rokoviid2 = response.data;
        })
        .catch(error => window.console.log(error.message));
    },

    getRokovi(idKolegija) {
      var config = {
        headers: {
          "Content-Type": "application/json",
          issApiAccessToken: this.token
        }
      };
      var url =
        "https://is.sum.ba:4443/ISSApi/resources/fakulteti/" +
        this.idFakulteta +
        "/studiji/" +
        this.idStudija +
        "/kolegiji/" +
        idKolegija +
        "/rokovi?akademskaGodina=" + this.trenGodina;
      axios
        .get(url, config)
        .then(response => {
          this.rokoviid = response.data;
          // window.console.log(this.rokoviid);
        })
        .catch(error => window.console.log(error.message));

      var url1 =
        "https://is.sum.ba:4443/ISSApi/resources/fakulteti/" +
        this.idFakulteta +
        "/studiji/" +
        this.idStudija +
        "/kolegiji//rokovi?akademskaGodina=" + this.trenGodina + "&ptiId.id=" +
        this.test.ptiId.id +
        "&" +
        this.strRoka;
      // window.console.log(url);
      axios
        .get(url1, config)
        .then(response => {
          this.rokoviid2 = response.data;
          // window.console.log(this.rokoviid2);
        })
        .catch(error => window.console.log(error.message));
    },
    getRok(strRoka) {
      var config = {
        headers: {
          "Content-Type": "application/json",
          issApiAccessToken: this.token
        }
      };
      var url =
        "https://is.sum.ba:4443/ISSApi/resources/fakulteti/" +
        this.idFakulteta +
        "/studiji/" +
        this.idStudija +
        "/kolegiji/" +
        this.idKolegija +
        "/rokovi?akademskaGodina=" + this.trenGodina + "&" +
        strRoka;
      // window.console.log(url);
      axios
        .get(url, config)
        .then(response => {
          this.rokoviid2 = response.data;
          // window.console.log(this.rokoviid2);
        })
        .catch(error => window.console.log(error.message));
    }
  },

  data: () => ({
    trenGodina: new Date().getFullYear() - 1 + "/" + new Date().getFullYear(),
    tipRoka: undefined,
    PomVarRok: [],
    PomVarSem: [],
    progress: false,
    novovrijeme: null,
    novovrijeme1: null,
    token: "",
    idFakulteta: null,
    idStudija: null,
    idKolegija: "",
    strRoka: "",
    filter: [],
    semestar: undefined,
    password: "issapi",
    startPaginacija: 0,
    brojac: 0,
    rokoviidBrojac: [],
    panel: [true],
    Sastavnice: [
      {
        title: "Agronomski i prehrambeno-tehnološki fakultet",
        id: 2,
        user: "APTF_ISSAPI"
      },
      {
        title: "Akademija likovnih umjetnosti",
        id: 7,
        user: "ALU_ISSAPI"
      },
      {
        title: "Ekonomski fakultet",
        id: 3,
        user: "EF_ISSAPI"
      },
      {
        title: "Fakultet prirodoslovno-matematičkih i odgojnih znanosti",
        id: 5,
        user: "FPMOZ_ISSAPI"
      },
      {
        title: "Fakultet strojarstva, računarstva i elektrotehnike",
        id: 6,
        user: "FSR_ISSAPI"
      },
      {
        title: "Fakultet zdravstvenih studija",
        id: 10,
        user: "FZS_ISSAPI"
      },
      {
        title: "Farmaceutski fakultet",
        id: 999000000146117,
        user: "FARFMO_ISSAPI"
      },
      {
        title: "Filozofski fakultet",
        id: 4,
        user: "FFMO_ISSAPI"
      },
      {
        title: "Građevinski fakultet",
        id: 11,
        user: "GF_ISSAPI"
      },
      {
        title: "Medicinski fakultet",
        id: 8,
        user: "MF_ISSAPI"
      },
      {
        title: "Pravni fakultet",
        id: 9,
        user: "PF_ISSAPI"
      }
    ],
    PomVar3: [],
    studiji: [],
    Fakulteti: [],
    odabraniSemestar: undefined,
    test: [],
    kolegiji: [],
    df: [],
    rokoviid: [],
    rokoviid2: [],

    stringRokova: [
      {
        roki: "Jesenski ispitni rok",
        a: "JR"
      },
      {
        roki: "Ljetni ispitni rok",
        a: "LR"
      },
      {
        roki: "Zimski ispitni rok",
        a: "ZR"
      },
      {
        roki: "Proljetni ispitni rok",
        a: "PR"
      },
      {
        roki: "Dekanski ispitni rok",
        a: "DR"
      }
    ],
    semestri: ["1", "2", "3", "4", "5", "6"]
  }),

 computed: {
    glavniFilter: function() {
      let semestar = this.semestar;
      let rok = this.tipRoka;
      let idKolegija = this.idKolegija;
     /// window.console.log(semestar)
     /// window.console.log(rok)
     /// window.console.log(idKolegija)
      return this.rokoviidBrojac.filter(function(item) {
        if (semestar !== undefined) {
          if (rok !== undefined) {
            if (idKolegija !== "") {
              return (
                item.predmet.id === idKolegija &&
                (item.ispitni_rok.semestar === semestar || item.ispitni_rok.semestar === 0) &&
                item.ispitni_rok.vrsta_roka === rok
              );
            } else {
              return (
                item.ispitni_rok.vrsta_roka === rok &&
                (item.ispitni_rok.semestar === semestar || item.ispitni_rok.semestar === 0)
              );
            }
          } else if (idKolegija !== "") {
            return (
              item.predmet.id === idKolegija &&
              (item.ispitni_rok.semestar === semestar || item.ispitni_rok.semestar === 0)
            );
          } else {
            return item.ispitni_rok.semestar === semestar || item.ispitni_rok.semestar === 0;
          }
        } else if (rok !== undefined) {
          if (idKolegija !== "") {
            return item.predmet.id === idKolegija && item.ispitni_rok.vrsta_roka === rok;
          } else {
            return item.ispitni_rok.vrsta_roka === rok;
          }
        } else {
          return item.predmet.id === idKolegija;
        }
      });
    } 
    // filterPoSemestru: function() {
    //   let semestar = this.semestar;
    //   let rok = this.tipRoka;
    //   return this.rokoviidBrojac.filter(function(item) {
    //     if (rok !== "") {
    //       return (item.semestar === semestar || item.semestar === 0) && item.vrstaRoka === rok;
    //     } else
    //     {return item.semestar === semestar || item.semestar === 0}
    //   });
    // },
    // filterPoPredmetu: function() {
    //   let idKolegija = this.idKolegija;
    //   let rok = this.tipRoka;
    //   return this.rokoviidBrojac.filter(function(item) {
    //     if (rok !== "") {
    //       return item.ptiId.id === idKolegija && item.vrstaRoka === rok;
    //     } else {
    //       return item.ptiId.id === idKolegija;
    //     }
    //   });
    // },
    // filterPoRoku: function() {
    //   let semestar = this.semestar;
    //   let rok = this.tipRoka;
    //   let idKolegija = this.idKolegija;
    //   return this.PomVar3.filter(function(item) {
    //     if (idKolegija !== "") {
    //       return item.ptiId.id === idKolegija && item.vrstaRoka === rok && (item.semestar === semestar || item.semestar === 0);
    //     } else {
    //       return item.vrstaRoka === rok && (item.semestar === semestar || item.semestar === 0);
    //     }

    //   });
    // }
  }
};
</script>

<style>
th,
td {
  border: 2px solid black;
  border-left: 0px none;
  border-right: 0px none;
  text-align: center;
  border-top: 0px none;
}

tr:hover {
  background-color: whitesmoke;
}
#tableHead {
  background-color: #084776;
  color: white;
}
table {
  width: 100%;
  border-collapse: collapse;
}

#mobilnitd {
  border: 2px solid black;
}
tr:nth-child(even) {
  background: whitesmoke;
}
</style>
